import Vue from 'vue';
import App from './App.vue';
import { CoreVue } from './core';
import Plugins from './plugins';
import router from './plugins/router';
import Modules from './modules';
import Filters from './filters';

Vue.config.productionTip = false;
const options = {
  router,
};

Vue.use(CoreVue, options);
Vue.use(Plugins, options);
Vue.use(Filters, options);
Vue.use(Modules, options);

new Vue({
  router,
  mounted() {
    window.core = this;
    this.$core.init();
  },
  render: h => h(App),
}).$mount('#mag-app');
